<template>
  <div class="vote-grid">
    <v-btn
      color="error--text"
      fab
      class="vote-grid__down"
      :disabled="isVoting"
      :loading="isVoting"
      @click="dislike"
    >
      <v-icon>thumb_down</v-icon>
    </v-btn>
    <q-card elevation="6" class="vote-grid__img" v-bind="q"></q-card>
    <v-btn
      color="success--text"
      fab
      class="vote-grid__up"
      :disabled="isVoting"
      :loading="isVoting"
      @click="like"
    >
      <v-icon>thumb_up</v-icon>
    </v-btn>
  </div>
</template>
<script>
import api from "@/plugins/axios";
export default {
  data: () => ({
    q: {},
    isVoting: false
  }),
  created() {
    this.getRandom();
  },
  methods: {
    async getRandom() {
      this.q = (await api.get("q/random")).data;
    },
    async like() {
      if (this.isVoting) return;
      this.isVoting = true;
      await api.post(`q/${this.q.id}/like`);
      await this.getRandom();
      this.isVoting = false;
    },
    async dislike() {
      if (this.isVoting) return;
      this.isVoting = true;
      await api.post(`q/${this.q.id}/dislike`);
      await this.getRandom();
      this.isVoting = false;
    }
  }
};
</script>
<style lang="stylus">
@import '~vuetify/src/stylus/settings/_variables';

.vote-grid {
  display: grid;
  grid: 'down img up' 1fr / min-content minmax(max-content, 500px) min-content;
  justify-content: center;
  align-items: center;
  justify-items: center;
  grid-gap: 15px;

  @media $display-breakpoints.sm-and-down {
    grid: 'img img' 1fr 'down up' auto / 1fr 1fr;
    max-width: 500px;
    margin: auto;
  }

  &__down {
    grid-area: down;
  }

  &__img {
    grid-area: img;
    width: 100%;
  }

  &__up {
    grid-area: up;
  }
}
</style>
